import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ZapiWootSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/zapiwoot'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'zapiwoot_settings_index',
          component: ZapiWootSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
